import shareDirective from './share.directive.js';
import ShareService from './share.service.js';

angular.module('app.share', [])
  .directive('share', shareDirective)
  .service('ShareService', ShareService);



/** WEBPACK FOOTER **
 ** ./src/app/components/share/share.module.js
 **/